import CartIcon from "@/assets/templates/icons/cartIcon";
import PhoneIcon from "@/assets/templates/icons/phoneIcon";
import { useTemplateContext } from '@/context/TemplateProvider'

import Layout from "./views";

const Account9Template = () => {
  const { template } = useTemplateContext()

  return (
    <Layout.Container backgroundImage={template.sections.hero.backgroundImage}>
      <Layout.ImageCover />
      <Layout.Header>
        <Layout.HeaderContent>
          <Layout.Title>{template.logo.text}</Layout.Title>
          <Layout.Menu>
            <Layout.PhoneButton>
              <PhoneIcon />
              000-000-0000
            </Layout.PhoneButton>
            <CartIcon />
          </Layout.Menu>
        </Layout.HeaderContent>
      </Layout.Header>
      <Layout.Content>
        <Layout.HeroTitle>{template.sections.hero.title}</Layout.HeroTitle>
        <Layout.HeroDescription> {template.sections.hero.subtitle}</Layout.HeroDescription>
        <Layout.CTA>{template.sections.hero.ctaText}</Layout.CTA>
      </Layout.Content>
    </Layout.Container>
  );
};

export default Account9Template;
